import { render } from "./AiOnboardingEvaluatorPage.vue?vue&type=template&id=3a65a760&scoped=true"
import script from "./AiOnboardingEvaluatorPage.vue?vue&type=script&lang=js"
export * from "./AiOnboardingEvaluatorPage.vue?vue&type=script&lang=js"

import "./AiOnboardingEvaluatorPage.vue?vue&type=style&index=0&id=3a65a760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a65a760"]])

export default __exports__